import { Link } from "@tanstack/react-router";

import { Button } from "@/components/ui/button";

export function NotFoundRoute() {
  return (
    <div className="container flex min-h-[60vh] flex-col items-center justify-center gap-4 py-16 text-center">
      <p className="text-sm font-medium uppercase tracking-wide text-muted-foreground">404</p>
      <h1 className="text-2xl font-semibold tracking-tight">That page doesn't exist</h1>
      <p className="max-w-md text-sm text-muted-foreground">
        The link may be stale, or the page has moved. Head back to your dashboard to keep going.
      </p>
      <Button asChild className="mt-2">
        <Link to="/dashboard">Back to dashboard</Link>
      </Button>
    </div>
  );
}
